// extracted by mini-css-extract-plugin
export default {"cls1":"vfOxwasX5mTGTy1B9eY6","cls2":"cLtuzxb0mIu0ZKWhlHuo vfOxwasX5mTGTy1B9eY6"};